import { useQuery } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { AdminRole } from '@low6-pickem/api-types';

export interface AdminMeResponse {
  id: string;
  email: string;
  name: string;
  role: AdminRole;
  allowedTenantIds: string[] | null;
  allowedGameTypes: string[] | null;
}

export const getAdminMe = (): Promise<AdminMeResponse> => api.get('/me');

export const useGetAdminMeQuery = () =>
  useQuery({
    queryKey: ['admin', 'me'],
    queryFn: getAdminMe,
    staleTime: 5 * 60 * 1000,
  });
